import BookItem from "../common/bookItem";
import { mouseEvent } from "../common/mouse_event";
import ReadSentenceShort from "./read_sentence_short";
import {store} from '../../../store';
import { PLAYER_TYPE } from "./player_type";
export default class PlaySound extends BookItem {
    normalFrame = 0;    //按鈕普通狀態的影格，預設為0
    constructor(el, target) {
        super(el, target);
        this.connectNumber = this.el.connectNumber;
        this.fileName = el.fileName;
        this.needPlayer = el.needPlayer;
        this.needStopBtn = el.needStopBtn;

        this.isTrigger = false;

        //測試用
        this.fileName = "audio/" + this.fileName;

        this.playerType = PLAYER_TYPE.SIMPLE;
        this.playerTag = target.parent.tag;
    }

    init() {
        //若需要停止功能則代表點擊後會切換按鈕圖片
        this.needStopBtn ? this.add_mouse_event() : mouseEvent.add_mouse_event(this);
        this.target.gotoAndStop(0);
    }

    trigger(needRemove = true) {
        if (this.isTrigger) {
            if (this.needStopBtn) {
                this.audio_stop();
            }
            return;
        } else {
            store.playerType = this.playerType;
            this.audio_play();
            if (needRemove) {
                //尋找頁面上所有短句並停止trigger
                for (let i = 0; i < this.itemControl.bookItems.length; i++) {
                    if (this.itemControl.bookItems[i] instanceof ReadSentenceShort) {
                        this.itemControl.bookItems[i].stopTrigger();
                    }
                }
            }
        }
        console.log('do something(play sound)');
    }

    audio_play() {
        if (this.fileName == "" || this.fileName == null) {
            console.log("尚未指定音檔!!");
            return;
        }

        // console.log('現在播放', this.fileName);
        // console.log(this.needPlayer ? '需要播放器' : '不要播放器');
        // console.log(this.needStopBtn ? '可以點擊停止' : '不能點擊停止');

        window.soundManager.audioPlayerPlay(this.fileName, function () {
            this.isTrigger = false;
            window.soundManager.switchMediaDisplay(false);
            this.target.gotoAndStop(this.normalFrame);
            this.itemControl.loader.singleAntialiasing(this.target);
        }.bind(this), this.playerTag);
        this.itemControl.loader.singleAntialiasing(this.target);
        window.soundManager.switchMediaDisplay(this.needPlayer);

        this.isTrigger = true;
    }

    audio_stop() {
        window.soundManager.audioPlayerStop();
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
            let frame = this.isTrigger ? 4 : 1;
            this.target.gotoAndStop(frame);
        });
        this.target.addEventListener("mouseover", () => {
            if (this.target.currentFrame == 1 || this.target.currentFrame == 4) return;
            let frame = this.isTrigger ? 4 : 1;
            this.target.gotoAndStop(frame);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
        this.target.addEventListener("mouseout", () => {
            let frame = this.isTrigger ? 3 : this.normalFrame;
            this.target.gotoAndStop(frame);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
        this.target.addEventListener("mousedown", () => {
            let frame = this.isTrigger ? 5 : 2;
            this.target.gotoAndStop(frame);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
    }
}